var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUserManage = function SvgUserManage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.5C11.7344 10.5 14 8.27344 14 5.5C14 2.76562 11.7344 0.5 9 0.5C6.22656 0.5 4 2.76562 4 5.5C4 8.27344 6.22656 10.5 9 10.5ZM9 1.75C11.0312 1.75 12.75 3.46875 12.75 5.5C12.75 7.57031 11.0312 9.25 9 9.25C6.92969 9.25 5.25 7.57031 5.25 5.5C5.25 3.46875 6.92969 1.75 9 1.75ZM12.5547 12.4141L11.0312 17.7656L9.70312 13.8203L10.6797 12.8438C11.0703 12.4531 10.7969 11.75 10.25 11.75H7.75C7.16406 11.75 6.89062 12.4531 7.28125 12.8438L8.25781 13.8203L6.92969 17.7656L5.40625 12.4141C2.51562 12.4531 0.25 14.7578 0.25 17.6484V18.625C0.25 19.6797 1.07031 20.5 2.125 20.5H15.875C16.8906 20.5 17.75 19.6797 17.75 18.625V17.6484C17.75 14.7578 15.4453 12.4531 12.5547 12.4141ZM2.125 19.25C1.77344 19.25 1.5 18.9766 1.5 18.625V17.6484C1.5 15.8125 2.75 14.2109 4.46875 13.7812L6.07031 19.25H2.125ZM7.75 19.25L9 15.6172L10.2109 19.25H7.75ZM16.5 18.625C16.5 18.9766 16.1875 19.25 15.875 19.25H11.8906L13.4922 13.7812C15.2109 14.2109 16.4609 15.8125 16.4609 17.6484V18.625H16.5Z",
    fill: "#666666"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserManage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user_manage.be7160b6.svg";
export { ForwardRef as ReactComponent };